import SystemSearch from "../js/components/groupManagement/SystemSearch.react";
export default SystemSearch;
